import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Security_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="security_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Security and Permissions Overview</h2>
              <p>
                Nexoid has two levels of security for individual records. The
                first is object level security which allows for high level
                access to a particular object type and the second is record
                level permission (RLP) Which allows the administrator to set
                ownership over a particular record.
              </p>
              <p>
                Both object level and record level permissions can be set at
                group or individual user-level.
              </p>
              <p>
                Some pre-built modules may include groups and API accounts with
                preset permissions. Only import and install modules from
                suppliers you trust.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Security_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/security/Security_overview.js